<template>
  <Toast/>
  <div class="row background-pale sm-pad">
    <div class="col">
      <div class="row">
        <div class="col">
          <div class="page-header centrer">
            <div class="row">
              <div class="col-1"/>
              <div class="col-10">
                <h1>Impression du suivi</h1>
              </div>
              <div class="col-1 text-right no-print">
                <Button class="no-print" label="Fermer" v-on:click="fermer"/>
              </div>
            </div>
            <h3 class="confidentiel">Confidentiel</h3>
            <h3 >
                {{ suivi.numeroFiche }}
            </h3>
            <div v-show="!isDataLoaded">
              <Skeleton />
            </div>
          </div>
        </div>
      </div>

      <div class="row condense-12 text-left">
        <div class="col">
          <table id="rapport" class="centrer w-75">
            <thead>
              <tr>
                <td>
                  <!--place holder for the fixed-position header-->
                  <div class="page-header-space"></div>
                </td>
              </tr>
            </thead>

            <tbody>
              <tr>
                <td >
                  <!--*** CONTENT GOES HERE ***-->
                  <h3 class="synopsis" >
                    Activité: {{ suivi.typeActiviteAfficher }}<br />
                    Confidentialité: {{ suivi.confidentialiteAfficher }}<br />
                    Statut: {{ suivi.statutAfficher }}<br /><br />
                    Suivi: {{ suivi.texte }}<br /><br />
                    Secteur: {{ suivi.secteurAssigneAfficher }} Intervenant: {{ suivi.intervenantAfficher }}<br />
                    Demandé le: {{ this.$commun.formatDateHeure(suivi.creerLe) }}<br />
                    Date complété: {{ this.$commun.formatDateHeure(suivi.completee) }}<br />
                    Date prévue: {{ this.$commun.formatDateHeure(suivi.prevue) }}<br />
                    Demandeur: {{ suivi.creerParDescription }}
                  </h3>
                </td>
              </tr>
            </tbody>

            <tfoot>
              <tr>
                <td>
                  <!--place holder for the fixed-position footer-->
                  <div class="page-footer-space"></div>
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <div class="page-footer centrer">
            <p>Généré le {{ getCurrentDateTime() }} par {{ profil.code }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import {mapGetters} from "vuex";

export default {
  name: "suiviRapportCDX0097",
  created() {
    // FIXME: ceci est un commentaire temporaire le temps de débugger
    // window.onafterprint = () => { window.close() }
  },
  mounted() {
    axios.defaults.headers.common["cleProfil"] = this.profil.cle
    this.$root.$refs.breadcrumbComp.ajout("Rapport du Suivi");
    this.genererDonneesAffichage();
  },
  data() {
    return {
      isDataLoaded: false,
    };
  },
  computed: {
    ...mapGetters({
      jeton: "cardex/jeton",
      profil: 'cardex/profil',
      suivi: "suivi/suivi",
    }),
  },
  methods: {
    genererDonneesAffichage() {
      this.isDataLoaded = true;
    },
    getCurrentDateTime() {
      return this.$commun.formatDateHeure(new Date())
    },
    showError(error) {
      this.$toast.add({
        severity: 'error',
        summary: 'Impression annulée',
        detail: 'Erreur lors de la génération de la page: ' + error,
        life: 5000
      })
    },
    fermer() {
      window.close()
    }
  },
  watch: {
    isDataLoaded: function(value) {
      if (!value)
        return
      // Add a short delay to let Vue finish rendering
      setTimeout(() => {
        window.print();
      }, 3000);
    }
  }
};
</script>

<style scoped>
.sm-pad {
  padding-top: 2em;
}
.synopsis {
  margin-bottom: 2em;
}

@media print {
  .page-header-space {
    height: 180px;
  }
  .synopsis {
    margin-top: -6em;
    margin-bottom: 2em;
  }
  #rapport {
    min-width: 100%;
  }
}
</style>